import React from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

// True when the backend refused an allot because the month is already allotted.
export const isAlreadyAllotted = (error) =>
  error?.response?.status === 409 &&
  error?.response?.data?.code === "ALREADY_ALLOTTED";

const ConfirmAllotDialog = ({ open, message, saving, onCancel, onConfirm }) => (
  <Dialog open={open} onClose={saving ? undefined : onCancel} maxWidth="xs">
    <DialogTitle>Month already allotted</DialogTitle>
    <DialogContent>
      <DialogContentText>
        {message ||
          "This month is already allotted. Confirm to add these quantities to the existing allotment."}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={saving}>
        Cancel
      </Button>
      <Button
        className="btn-contained"
        onClick={onConfirm}
        disabled={saving}
        startIcon={saving ? <CircularProgress size={16} /> : null}
      >
        Add to allotment
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmAllotDialog;
